<template>
  <div>
    <div class="upload-photo" v-if="type == 'select'">
      <div class="upload-list" v-for="(item,index) in uploadList" :key="index">
        <div style="height:100%" v-if="item.status === 'finished'">
          <img :src="item.url|img_oss('tubo_tiny')">
          <div class="upload-list-cover">
            <Icon type="ios-eye-outline" v-image-preview="{item:item.url,list:uploadList.map(item=>item.url)}"></Icon>
            <Icon type="ios-trash-outline" @click.native="handleRemove(item,uploadList)" v-show="!disabled"></Icon>
          </div>
        </div>
        <div v-else>
          <Progress v-if="item.showProgress" :percent="item.percentage"></Progress>
        </div>
      </div>
      <Upload :action="action" class="upload-list" v-show="!disabled" :on-success="successCall" :accept="accept" :default-file-list="defaultList" :multiple="!single" :on-error="error" :before-upload="before" :data="param" :ref="uuid">
        <Icon :type="single?'ios-camera':'ios-add'" style="width:58px;height:58px" size="20"></Icon>
      </Upload>
    </div>
    <div v-else-if="type == 'drag'">
      <div v-if="!disabled">
        <Upload :action="action" type="drag" :on-success="successCall" :show-upload-list="false" :accept="accept" :default-file-list="defaultList" :on-remove="handleRemove" :multiple="!single" :on-error="error" :before-upload="before" :data="param" :ref="uuid">
          <slot></slot>
          <div v-for="(item,index) in uploadList" :key="index">
            <div v-if="item.status !== 'finished'">
              <Progress v-if="item.showProgress" :percent="item.percentage"></Progress>
            </div>
          </div>
        </Upload>
      </div>
      <div v-else class="b-1 brd-3">
        <slot></slot>
      </div>
    </div>
    <div v-else>
      <Upload :action="action" :on-success="successCall" :disabled="!disabled" :accept="accept" :default-file-list="defaultList" :on-remove="handleRemove" :multiple="!single" :on-error="error" :before-upload="before" :data="param" :ref="uuid">
        <slot></slot>
      </Upload>
    </div>
  </div>
</template>

<script>
  import { _api, util } from '@/libs';
  import EXIF from 'exif-js'
  import MegaPixImage from '@koba04/ios-imagefile-megapixel'
  export default {
    name: 'PhotoUpload',
    model: { prop: 'img', event: 'change' },
    props: {
      // 双向绑定字段(single==true返回ossPath字符串，single==false返回字符串数组)
      img: { type: [String, Array] },
      // 禁用组件
      disabled: Boolean,
      // 单图多图，默认单图
      single: { type: Boolean, default: true },
      // 上传方式 ('select':图片选择框,'drag':拖拽)
      type: { type: String, default: 'select' },
      // 上传api
      action: { type: String, default: () => { return _api.baseUrl + _api.common.libThird.oss } },
      // 上传文件类型
      accept: { type: String, default: 'image/jpg,image/png,image/jpeg,image/bmp' },
      // 上传参数
      param: { type: Object, default: () => { return {} } },
      // 是否压缩，默认是
      resize: { type: Boolean, default: true },
      // 压缩参数
      resizeParam: { type: Object, default: () => { return { maxWidth: 1200, maxHeight: 1200, quality: 0.9 } } },
      // 上传成功回调
      success: { type: Function }
    },
    data() {
      return {
        uuid: util.uuid(),
        uploadList: [],
      }
    },
    computed: {
      defaultList() {
        let arr = []
        if (this.img) {
          arr = typeof this.img == 'string' ? [{ name: this.img, url: this.img, status: 'finished' }] : this.img.map(item => { return { name: item, url: item, status: 'finished' } })
        }
        if (this.$refs[this.uuid]) {
          this.uploadList = this.$refs[this.uuid].uploadList = arr
        }
        return arr
      },
    },
    methods: {
      // 上传之前
      before(file) {
        if (!this.disabled) {
          if (this.single) {
            this.$refs[this.uuid].clearFiles()
          }
          if (this.resize) {
            const _this = this
            EXIF.getData(file, function () {
              const orientation = EXIF.getTag(file, 'Orientation')
              const img = new MegaPixImage(file)
              const c = new Image()
              img.render(c, Object.assign(_this.resizeParam, { orientation }), () => {
                c.onload = () => {
                  _this.$refs[_this.uuid].post(Object.assign(util.urlToBlob(c.src), { name: file.name }))
                  _this.uploadList = _this.$refs[_this.uuid].fileList
                }
                c.onerror = _this.error
              })
            })
            return false
          }
        } else {
          return false
        }
      },
      // 上传成功回调
      successCall(payload, file, fileList) {
        Object.assign(file, { url: payload.ossPath })
        if (this.single) {
          this.$emit('change', payload.ossPath)
        } else {
          this.$emit('change', this.uploadList.filter(item => item.status == 'finished').map(item => item.url))
        }
        if (this.success) {
          this.success(payload, file, fileList)
        }
      },
      // 删除图片
      handleRemove(item, arr) {
        if (this.single) {
          this.$refs[this.uuid].clearFiles()
          this.uploadList = this.$refs[this.uuid].fileList
          this.$emit('change', null)
        } else {
          arr.splice(arr.indexOf(item), 1)
          this.$emit('change', this.uploadList.filter(item => item.status == 'finished').map(item => item.url))
        }
      },
      // 文件读取或上传失败
      error(error) {
        this.$Notice.error({ title: '图片解析或上传失败！' })
      },
    },
    mounted() {
      this.uploadList = this.$refs[this.uuid].fileList
    }
  }
</script>